@if (hasAnyPermission) {
  <section class="output-composition-card">
    <h1 class="title">Output Composition</h1>

    <mat-tab-group animationDuration="0ms" [selectedIndex]="defaultTabIndex" (selectedIndexChange)="onTabChanged($event)">
      <mat-tab label="Filename conventions">
        <app-filename-conventions-panel
          [filenameConventions]="filenameConventions"
          [loaded]="filenameConventionsLoaded"
          [canWrite]="canWriteFilenameConventions"
          [canAudit]="canAuditFilenameConventions"
          (createRange)="openCreateFilenameConventionDialog('range')"
          (createEv)="openCreateFilenameConventionDialog('ev')"
          (updateConvention)="openUpdateFilenameConventionDialog($event)"
          (deleteConvention)="openDeleteFilenameConventionDialog($event)"
          (viewConventionHistory)="openFilenameConventionHistoryDialog($event)"
        ></app-filename-conventions-panel>
      </mat-tab>

      <mat-tab label="File specifications">
        <app-file-specifications-panel
          [fileSpecifications]="fileSpecifications"
          [loaded]="fileSpecificationsLoaded"
          [canWrite]="canWriteFileSpecifications"
          [canAudit]="canAuditFileSpecifications"
          (createStills)="openCreateFileSpecificationDialog('stills')"
          (createVideos)="openCreateFileSpecificationDialog('videos')"
          (updateFileSpecification)="openUpdateFileSpecificationDialog($event)"
          (deleteFileSpecification)="openDeleteFileSpecificationDialog($event)"
          (viewFileSpecificationHistory)="openFileSpecificationHistoryDialog($event)"
        ></app-file-specifications-panel>
      </mat-tab>

      <mat-tab label="Output formulas">
        <app-output-formulas-panel
          [outputFormulas]="outputFormulas"
          [fileSpecifications]="fileSpecifications"
          [filenameConventions]="filenameConventions"
          [loaded]="outputFormulasLoaded"
          [canWrite]="canWriteOutputFormulas"
          [canAudit]="canAuditOutputFormulas"
          (createRange)="openCreateRangeOutputFormulaDialog()"
          (createEv)="openCreateEvOutputFormulaDialog()"
          (updateFormula)="openUpdateOutputFormulaDialog($event)"
          (deleteFormula)="openDeleteOutputFormulaDialog($event)"
          (viewFormulaHistory)="openOutputFormulaHistoryDialog($event)"
        ></app-output-formulas-panel>
      </mat-tab>
    </mat-tab-group>
  </section>
}
